import Icon from '../../Icon/Icon';
import { IconKeys } from '../../Icon/IconKeys';
import S from './TogglerStyles';
import { Props } from './types';

function Toggler({ type, trigger }: Props):JSX.Element {
  return (
    <S.Wrapper>
      <div className="label">
        <Icon iconKey={IconKeys.SPARK_ALERT} />
        <p> {type}</p>
      </div>
      <div className="trigger">
        <p>{trigger}</p>
      </div>
    </S.Wrapper>
  );
}

export default Toggler;
